import { prefix } from '@goldwasserexchange/react-topmodel';
export var rippleEffectPrefixer = prefix('RippleEffect');
